
import React, { useEffect, useRef } from "react";

const Global = ({yourAudioRef}) => {

  return (
    <div className="audio-player mb-5" style={{ margin: "0 auto", display:"none"}}>
      {/* src is assigned in App.js from the URL the backend returns */}
      <audio id="yourAudio" ref={yourAudioRef}  controls preload="none" />
    </div>
  );
};


export default Global;


